import { TableDefine } from '@/libs/tableHelper/type'
import { Epitaph } from '@/api/epitaph/Epitaph'
import { User } from '@/api/user/User'

// 数据表格的列定义
export default function getTableDefine (view: any): TableDefine<Epitaph> {
  const tableCols = [
    {
      title: '头像',
      type: {
        module: 'avatar',
        gender: (dataItem: User) => {
          return dataItem.gender || 1
        },
        previewSize: 50
      },
      key: 'picture'
    },
    {
      title: '名称',
      key: 'name',
      width: 100
    },
    {
      title: '生平事迹',
      minWidth: 300,
      type: {
        module: 'textarea',
        summary: 100
      },
      key: 'deeds'
    },
    {
      title: '创建时间',
      width: 200,
      key: 'createTime',
      type: {
        module: 'time',
        format: 'yyyy-MM-DD'
      }
    }
  ]

  const actions: any = [
    {
      name: 'view',
      title: '详情',
      onClick: (dataItem: Epitaph) => {
        view.onViewItem(dataItem)
      }
    },
    {
      name: 'view',
      title: '编辑',
      onClick: (dataItem: Epitaph) => {
        view.onEditItem(dataItem)
      }
    }
  ]

  return {
    tableCols,
    actions
  }
}
